const GetMIL1Reducer = (state = { type: 'LOADING_MI_L1_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_MI_L1_ACTION':
            return { ...state, type: 'LOADING_MI_L1_ACTION', loading: true };
        case 'SUCCESS_MI_L1_ACTION':
            return { ...action, loading: false };
        case 'ERROR_MI_L1_ACTION':
            return { ...state, type: 'ERROR_MI_L1_ACTION', loading: false, error: action.error };
        case 'RESET_MI_L1_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state
    }
}

const GetIsFavoriteL1Reducer = (state = { type: 'LOADING_IS_FAVORITE_L1_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_IS_FAVORITE_L1_ACTION':
            return { ...state, type: 'LOADING_IS_FAVORITE_L1_ACTION', loading: true };
        case 'SUCCESS_IS_FAVORITE_L1_ACTION':
            return { ...action, loading: false };
        case 'ERROR_IS_FAVORITE_L1_ACTION':
            return { ...state, type: 'ERROR_IS_FAVORITE_L1_ACTION', loading: false, error: action.error };
        case 'RESET_IS_FAVORITE_L1_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state
    }
}

const GetIsFavoriteL1L2Reducer = (state = { type: 'LOADING_IS_FAVORITE_L1_L2_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_IS_FAVORITE_L1_L2_ACTION':
            return { ...state, type: 'LOADING_IS_FAVORITE_L1_L2_ACTION', loading: true };
        case 'SUCCESS_IS_FAVORITE_L1_L2_ACTION':
            return { ...action, loading: false };
        case 'ERROR_IS_FAVORITE_L1_L2_ACTION':
            return { ...state, type: 'ERROR_IS_FAVORITE_L1_L2_ACTION', loading: false, error: action.error };
        case 'RESET_IS_FAVORITE_L1_L2_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state
    }
}

const GetMIL2Reducer = (state = { type: 'LOADING_MI_L2_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_MI_L2_ACTION':
            return { ...state, type: 'LOADING_MI_L2_ACTION', loading: true };
        case 'SUCCESS_MI_L2_ACTION':
            return { ...action, loading: false };
        case 'ERROR_MI_L2_ACTION':
            return { ...state, type: 'ERROR_MI_L2_ACTION', loading: false, error: action.error };
        case 'RESET_MI_L2_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state
    }
}


export {
    GetMIL1Reducer,
    GetIsFavoriteL1Reducer,
    GetIsFavoriteL1L2Reducer,
    GetMIL2Reducer,
}